const windowLocalStorage = {
    name: "windowLocalStorage",
    set(key, value) {
        window.localStorage.setItem(key, value);
    },
    async get(key) {
        let value = window.localStorage.getItem(key);
        return value;
    },
    async keys() {
        let keys = Object.keys(window.localStorage);
        return keys;
    },
    remove(key) {
        window.localStorage.removeItem(key);
    }
}


const storage = {

    transport: windowLocalStorage,
    prefix: "sbs_",
    clearExclude: [
        "last_server",
        "last_login",
        "theme"
    ],

    set(key, value) {

        //если объект, то обязательно конвертируем в строку
        if ((typeof value === 'object') && value !== null) {
            value = JSON.stringify(value);
        }

        this.transport.set(this.prefix + key, value);
    },

    async get(key) {

        let value = await this.transport.get(this.prefix + key);

        if (value !== null) {
            //пытаемся конвертировать из строки в объект
            try {
                value = JSON.parse(value);
            } catch (e) {
                //to do
            }
        }

        return value;
    },

    /**
     * Очищает все данные
     */
    clear() {
        let keys = this.transport.keys();

        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if (key.startsWith(this.prefix)) {

                let k = key.replace(this.prefix, "");

                if (!this.clearExclude.includes(k)) {
                    window.localStorage.removeItem(key);
                }
            }
        }
    },

}

export default storage;